<template lang="pug">
  label(class="dynamic-checkbox")
    e-svg-icon(
      class="dynamic-checkbox__icon"
      size="xs"
      :name="value === 'checked' ? 'checkbox-checked-primary' : 'checkbox-empty'"
    )
    input(
      :value="value === 'checked'"
      @change="$emit('update:value', $event.target.checked ? 'checked' : 'unchecked')"
      type="checkbox"
      class="dynamic-checkbox__input"
      :checked="value === 'checked'"
      :disabled="disabled"
      @keydown="onKeyDown"
    )
</template>

<script>
import ESvgIcon from '~/components/elements/icons/e-svg-icon'

export default {
  name: 'TemplatesDynamicCheckbox',
  components: {
    ESvgIcon
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: [Boolean, String],
      default: null
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disabled() {
      return this.field.documentFieldPreValue || this.isDisabled
    }
  },
  created() {
    this.setCheckbox()
  },
  methods: {
    onKeyDown(e) {
      if (e.ctrlKey && e.key === 'c') {
        this.$emit('copy')
      }
      if (e.ctrlKey && e.key === 'x') {
        this.$emit('cut')
      }
      if (e.key === 'Delete') {
        this.$emit('delete')
      }
    },
    setCheckbox() {
      if (!this.canEdit) {
        if (this.field.documentFieldPreValue === 'checked') {
          this.$emit('update:value', 'checked')
        } else {
          this.$emit('update:value', this.field.documentFieldValue === 'checked')
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dynamic-checkbox {
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  &__icon {
    width: 100%;
    height: 100%;
    cursor: pointer;
    @media (max-width: map-get($breakpoints, 'sm')) {
      height: 8px;
      width: 8px;
    }
  }
  &__input {
    opacity: 0;
    position: absolute;
    pointer-events: none;
  }
}
</style>
